// extracted by mini-css-extract-plugin
export default {"btn":"adminpanel_btn__-sHkb","section":"adminpanel_section__715He","content":"adminpanel_content__Uc469","card":"adminpanel_card__dK529"};